import axios from "axios";
import * as XLSX from "xlsx";

export const formatCurrency = (val) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    }).format(val || 0);

export const calculateCategoryTotals = (data, key) =>
    data.reduce((totals, item) => {
        const category = item[key] || "Uncategorized";
        if (!totals[category]) totals[category] = { total: 0, subcategories: [] };
        totals[category].total += item.TotalAmount;
        totals[category].subcategories.push(item);
        return totals;
    }, {});

export const fetchExpenses = async (url, month) => {
    const { data } = await axios.get(url);
    console.log(data);
    return data
        .map((e, idx) => ({
            ...e,
            id: e.id || idx,
            TotalAmount: parseFloat(e.Amount) || 0,
            ExpenseDate: e.ExpenseDate ? new Date(e.ExpenseDate) : null,
        }))
        .filter(
            (e) =>
                month === "All" || e.ExpenseDate?.getMonth() + 1 === parseInt(month)
        );
};

export const fetchIncomes = async (url, month) => {
    const { data } = await axios.get(url);
    return data
        .map((i, idx) => ({
            ...i,
            id: i.id || idx,
            TotalAmount: parseFloat(i.Amount) || 0,
            IncomeDate: i.IncomeDate ? new Date(i.IncomeDate) : null,
        }))
        .filter(
            (i) => month === "All" || i.IncomeDate?.getMonth() + 1 === parseInt(month)
        );
};

export const fetchMealCounts = async (url, month) => {
    const { data } = await axios.get(url);
    return data
        .map((item) => ({
            ...item,
            ParsedDate: item["Income.Date"] ? new Date(item["Income.Date"]) : null,
        }))
        .filter(
            (d) => month === "All" || d.ParsedDate?.getMonth() + 1 === parseInt(month)
        );
};

export const exportOperatingStatementExcel = ({
    userDetails,
    totalIncome,
    totalExpenses,
    net,
    incomeData,
    expenseData,
    groupedMealCounts,
    getDepartment,
    getYear,
    getMonthString,
    formatCurrency,
}) => {
    const coverData = [
        ["Operating Statement Report"],
        [`School District: ${userDetails?.schoolDistrictName || "N/A"}`],
        [`Department: ${getDepartment()}`],
        [`Month: ${getMonthString()}`],
        [`Year: ${getYear()}`],
        [`Total Income: ${formatCurrency(totalIncome)}`],
        [`Total Expenses: ${formatCurrency(totalExpenses)}`],
        [`Net: ${formatCurrency(net)}`],
    ];

    const incomeSheet = XLSX.utils.json_to_sheet(incomeData);
    const expenseSheet = XLSX.utils.json_to_sheet(expenseData);
    const mealSheet = XLSX.utils.json_to_sheet(groupedMealCounts);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(coverData), "Cover");
    XLSX.utils.book_append_sheet(wb, incomeSheet, "Income");
    XLSX.utils.book_append_sheet(wb, expenseSheet, "Expenses");
    XLSX.utils.book_append_sheet(wb, mealSheet, "MealCounts");

    const fileName = `P&L_${getDepartment()}_${getYear()}-${getMonthString()}.xlsx`;
    XLSX.writeFile(wb, fileName);
};